module.exports = __webpack_public_path__ + "static/media/evergrin.e3e44932.jpg";